<!-- languageswitcherlist.vue -->
<template>
  <v-list
    dense
    class="py-0"
    style="max-height: 250px; overflow-y: scroll; max-width: 180px"
    :style="{
      background: headColor,
      color: textColor,
    }"
  >
    <v-list-item-group :style="{color: textColor}">
      <template v-for="(item, i) in filteredLanguages">
        <v-list-item
          :key="item.lang"
          @click="selectLanguage(item)"
          class="px-4 language-item"
          :class="{ 'active-lang': item.lang === currentLang }"
        >
          <v-list-item-avatar size="28" class="mr-3">
            <img
              :src="item.flag"
              :alt="item.name"
              class="rounded-flag"
              width="28"
              height="28"
            />
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title class="font-weight-medium" :style="{ color: textColor}">
              {{ item.name }}
            </v-list-item-title>
            <v-list-item-subtitle class="text-caption opacity-80" :style="{ color: textColor}">
              {{ $t(`language.lang.${item.lang}`) || item.lang }}
            </v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action>
            <v-icon v-if="item.lang === currentlanguage" class="pulse-check" :style="{ color: textColor}">
              mdi-check-circle
            </v-icon>
          </v-list-item-action>
        </v-list-item>

        <v-divider
          v-if="i < filteredLanguages.length - 1"
          :key="'div-' + item.lang"
          :style="{ borderColor: hexToRgba(textColor, 0.3) }"
        />
      </template>
    </v-list-item-group>

    <div
      v-if="!filteredLanguages.length"
      class="text-center pa-5 opacity-70 text-caption"
      :style="{ color: textColor}"
    >
      {{ $t("language.no_languages_available") }}
    </div>
  </v-list>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "languageswitcherlist",

  props: {
    currentLang: { type: String, required: true },
    textColor: { type: String, default: "#2c3e50" },
    headColor: { type: String, default: "#ffffff" },
  },

  data() {
    return {
      allLanguages: [
        {
          lang: "en_US",
          name: "English (US)",
          flag: "https://flagcdn.com/us.svg",
        },
        {
          lang: "en_GB",
          name: "English (UK)",
          flag: "https://flagcdn.com/gb.svg",
        },
        { lang: "fa", name: "فارسی", flag: "https://flagcdn.com/ir.svg" },
        { lang: "ar", name: "العربية", flag: "https://flagcdn.com/sa.svg" },
        {
          lang: "ar_ae",
          name: "العربية (الإمارات)",
          flag: "https://flagcdn.com/ae.svg",
        },
        {
          lang: "ar_iq",
          name: "العربية (العراق)",
          flag: "https://flagcdn.com/iq.svg",
        },
        { lang: "de", name: "Deutsch", flag: "https://flagcdn.com/de.svg" },
        { lang: "fr", name: "Français", flag: "https://flagcdn.com/fr.svg" },
        { lang: "hy", name: "Հայերեն", flag: "https://flagcdn.com/am.svg" },
        { lang: "ru", name: "Русский", flag: "https://flagcdn.com/ru.svg" },
        { lang: "tr", name: "Türkçe", flag: "https://flagcdn.com/tr.svg" },
        { lang: "zh_CN", name: "简体中文", flag: "https://flagcdn.com/cn.svg" },
        { lang: "zh_TW", name: "繁體中文", flag: "https://flagcdn.com/tw.svg" },
      ],
    };
  },

  computed: {
    ...mapGetters("localstorage", [
      "alllangs",
      "defaultLang",
      "currentlanguage",
    ]),
    filteredLanguages() {
      if (!this.alllangs || this.alllangs.length === 0) return [];
      const available = new Set(this.alllangs);
      if (this.defaultLang) available.add(this.defaultLang);
      return this.allLanguages.filter((l) => available.has(l.lang));
    },
  },

  methods: {
    ...mapActions("localstorage", ["setCurrentLanguage"]),

    selectLanguage(item) {
      if (item.lang === this.currentLang) {
        return;
      }
      this.$emit("source-changed", item.lang);
      setTimeout(() => {
        this.setCurrentLanguage(item.lang);
      }, 300);
    },

    hexToRgba(hex, alpha = 1) {
      const r = parseInt(hex.slice(1, 3), 16);
      const g = parseInt(hex.slice(3, 5), 16);
      const b = parseInt(hex.slice(5, 7), 16);
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    },
  },
};
</script>

<style scoped>
.language-switcher-submenu {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3) !important;
  min-width: 220px;
  padding-top: 0px;
  padding-bottom: 0px;
  margin: 0px;
}

.rounded-flag {
  object-fit: cover;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
}
.language-item,
.font-weight-medium,
.text-caption {
  color: inherit !important;
  background-color: inherit !important;
}

.language-item:hover {
  background-color: rgba(255, 255, 255, 0.15) !important;
}

.active-lang {
  background-color: rgba(255, 255, 255, 0.2) !important;
}

.opacity-80 {
  opacity: 0.8;
}
.opacity-70 {
  opacity: 0.7;
}

/* اسکرول زیبا */
.v-list::-webkit-scrollbar {
  width: 6px;
}
.v-list::-webkit-scrollbar-track {
  background: transparent;
}
.v-list::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 3px;
}
.v-list::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.5);
}
hr {
  margin: 0px;
  padding: 0px;
}
.pulse-check {
  animation: pulse 2s infinite ease-in-out;
  color: inherit !important;
  background-color: inherit !important;
}

@keyframes pulse {
  0%,
  100% {
    transform: scale(0.9);
    opacity: 0.8;
  }
  50% {
    transform: scale(1.05);
    opacity: 1;
  }
}
</style>
